import React, { useContext } from 'react';
import { FormOptionsContext } from '$/components/ui/Form';
import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';

import {
  ProductHuntPromoInteractionDetails,
  useProductHuntPostQuery,
} from '$/GraphQL/schema/schema';
import { FeaturedOnProductHunt } from './FeaturedOnProductHunt';
import { css } from '@emotion/react';
import tw from 'twin.macro';
import { FilledMarkdown } from '$/components/ui/EditableInput/DangerouslySetInnerHTML';
import EDate from '$/shared/frontend/utils/EDate';

export const ProductHuntPromoCardTitle: React.FC = () => {
  const { interaction } = useCardContext();
  const { onSubmit } = useContext(FormOptionsContext);

  const phDetails = interaction.details?.integration as
    | ProductHuntPromoInteractionDetails
    | undefined;

  const postQuery = useProductHuntPostQuery({
    variables: {
      ewebinarId: interaction.ewebinar!.id,
      slug: phDetails?.slug ?? '',
    },
    skip:
      !phDetails ||
      (Boolean(phDetails.lastUpdated) &&
        new EDate(new Date().toISOString()).diffInMinutes(new EDate(phDetails.lastUpdated)) < 5),
  });

  if (!phDetails) return null;

  let post = phDetails.post;
  if (postQuery.data?.productHuntPost) {
    post = postQuery.data.productHuntPost;
  }

  if (!interaction.details) return null;
  const integration = interaction.integration as unknown as
    | ProductHuntPromoInteractionDetails
    | undefined;

  const openPH = (): void => {
    onSubmit();
  };

  return (
    <div
      className='flex items-center relative w-full text-white'
      css={css`
        ${tw`rounded-2xl border border-gray-300 px-3/4e py-1e`}
        background: #eb491a;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `}
    >
      <FeaturedOnProductHunt
        onClick={openPH}
        size='card'
        votes={post?.votesCount ?? integration?.post?.votesCount}
      />
    </div>
  );
};

export const ProductHuntPromoCard: React.FC = () => {
  const { interaction } = useCardContext();
  const details = interaction.details!;

  return (
    <>
      <ProductHuntPromoCardTitle />
      <CardMain.Body>
        <div className='flex items-center mb-1e'>
          {false && (
            <img
              className='h-1_5e w-1_5e mr-1/2e'
              src={(details.integration as ProductHuntPromoInteractionDetails)?.post?.thumbnail.url}
            />
          )}
          <CardMain.Title
            css={css`
              color: #eb491a;
            `}
            className='flex text-lg mb-0'
          >
            <FilledMarkdown md={interaction.title()} />
          </CardMain.Title>
        </div>

        <CardMain.Description>{interaction.description()}</CardMain.Description>
        <CardMain.SubmitButton
          className='px-2e'
          backClassName='mt-2'
          css={css`
            background-color: #eb491a !important;
          `}
        >
          {details.buttonText || 'Come support us!'}
        </CardMain.SubmitButton>
      </CardMain.Body>
    </>
  );
};

export const NoBodyCard: React.FC = () => {
  return null;
};
